import { render, staticRenderFns } from "./CriterialForStudent.vue?vue&type=template&id=575db9c0&scoped=true"
import script from "./CriterialForStudent.vue?vue&type=script&lang=js"
export * from "./CriterialForStudent.vue?vue&type=script&lang=js"
import style0 from "./CriterialForStudent.vue?vue&type=style&index=0&id=575db9c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575db9c0",
  null
  
)

export default component.exports